<template>
    <remote-js :src="src" @load-js-finish="callBack"/>
</template>
<script>
    export default {
        props: {
            src: {
                type: String,
                required: true
            },
            callBack: {
                type: Function,
                default: () => {}
            }
        },
        components: {
            'remote-js': {
                render(createElement) {
                    return createElement('script', {
                        attrs: {
                            type: 'text/javascript',
                            src: this.src
                        },
                        on: {
                            load: () => {
                                this.$emit('load-js-finish')
                            }
                        }
                    });
                },
                props: {
                    src: {type: String, required: true},
                },
            }
        },
        created() {

        }
    };
</script>
